<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9.12,11.07C9.12,11.07,11.12,9.05,11.12,9.05C11.12,9.05,11.83,9.76,11.83,9.76C11.83,9.76,15.83,5.72,15.83,5.72C15.83,5.72,10.17,0,10.17,0C10.17,0,6.17,4.04,6.17,4.04C6.17,4.04,6.88,4.75,6.88,4.75C6.88,4.75,4.88,6.77,4.88,6.77C4.88,6.77,9.12,11.07,9.12,11.07C9.12,11.07,9.12,11.07,9.12,11.07ZM2,12.97C2,12.97,6,12.97,6,12.97C6.28,12.97,6.53,12.86,6.71,12.67C6.71,12.67,7.71,11.66,7.71,11.66C7.71,11.66,4.29,8.21,4.29,8.21C4.29,8.21,1.29,11.24,1.29,11.24C1.11,11.42,1,11.68,1,11.96C1,12.51,1.45,12.97,2,12.97C2,12.97,2,12.97,2,12.97ZM15,13.98C15,13.98,1,13.98,1,13.98C0.45,13.98,0,14.43,0,14.99C0,15.55,0.45,16,1,16C1,16,15,16,15,16C15.55,16,16,15.55,16,14.99C16,14.43,15.55,13.98,15,13.98C15,13.98,15,13.98,15,13.98Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Highlight',
} as DefineComponent
</script>
